import React, { useState } from "react";

const POLICY_FILE = "/policies/Indian_Odyssey_Trips_Travel_Terms_and_Conditions.pdf";
const POLICY_TITLE = "Travel Terms & Conditions";

const PolicyLinks = () => {
  const [showPolicy, setShowPolicy] = useState(false);

  return (
    <>
      <div className="policy-links-widget" aria-label="Policy document actions">
        <button
          type="button"
          className="btn btn-outline-light btn-sm shadow-sm"
          onClick={() => setShowPolicy(true)}
        >
          <i className="bi bi-file-earmark-text me-2"></i>
          View Policy
        </button>
        <a
          className="btn btn-warning btn-sm shadow-sm"
          href={POLICY_FILE}
          download
        >
          <i className="bi bi-download me-2"></i>
          Download Policy
        </a>
      </div>

      {showPolicy && (
        <div
          className="policy-modal-backdrop"
          role="dialog"
          aria-modal="true"
          aria-labelledby="policy-modal-title"
        >
          <div className="policy-modal">
            <div className="policy-modal-header">
              <h2 id="policy-modal-title">{POLICY_TITLE}</h2>
              <div className="d-flex gap-2">
                <a
                  className="btn btn-outline-secondary btn-sm"
                  href={POLICY_FILE}
                  target="_blank"
                  rel="noreferrer"
                >
                  Open
                </a>
                <a
                  className="btn btn-warning btn-sm"
                  href={POLICY_FILE}
                  download
                >
                  Download
                </a>
                <button
                  type="button"
                  className="btn btn-outline-dark btn-sm"
                  aria-label="Close policy viewer"
                  onClick={() => setShowPolicy(false)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
            <iframe
              title={POLICY_TITLE}
              className="policy-modal-frame"
              src={POLICY_FILE}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PolicyLinks;
